module.exports = __webpack_public_path__ + "img/1.bfd233d6.jpg";